import { baseApi } from "./api";

// ---------- Response types ----------

export interface AiCostsOverview {
  today: PeriodCost;
  this_week: PeriodCost;
  this_month: PeriodCost;
}

export interface PeriodCost {
  cost: number;
  chat_cost: number;
  translation_cost: number;
  tokens: number;
  translations: number;
  requests: number;
  deepl_characters: number;
  deepl_requests: number;
  elevenlabs_characters: number;
  elevenlabs_requests: number;
}

export interface AiCostsSummaryUser {
  uid: string;
  user_id: number;
  name: string | null;
  email: string | null;
  role: string;
  chat_tokens: number;
  chat_prompt_tokens: number;
  chat_completion_tokens: number;
  chat_requests: number;
  chat_cost_usd: number;
  translation_count: number;
  translation_cost_usd: number;
  total_cost_usd: number;
}

export interface AiCostsSummaryResponse {
  month: string;
  total_cost_usd: number;
  total_chat_cost_usd: number;
  total_translation_cost_usd: number;
  total_tokens: number;
  total_translations: number;
  users: AiCostsSummaryUser[];
}

export interface AiCostsTimeseriesDay {
  date: string;
  chat_cost_usd: number;
  translation_cost_usd: number;
  total_cost_usd: number;
  chat_tokens: number;
  translation_count: number;
  deepl_characters: number;
  deepl_requests: number;
  elevenlabs_characters: number;
  elevenlabs_requests: number;
}

export interface AiCostsTimeseriesResponse {
  from: string;
  to: string;
  total_cost_usd: number;
  total_chat_cost_usd: number;
  total_translation_cost_usd: number;
  days: AiCostsTimeseriesDay[];
}

// ---------- API endpoints ----------

export const aiCostsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAiCostsOverview: builder.query<AiCostsOverview, void>({
      query: () => "/admin/ai-costs/overview",
    }),

    getAiCostsSummary: builder.query<AiCostsSummaryResponse, { month?: string } | void>({
      query: (params) => {
        const month = params && "month" in params ? params.month : undefined;
        return `/admin/ai-costs/summary${month ? `?month=${month}` : ""}`;
      },
    }),

    getAiCostsTimeseries: builder.query<
      AiCostsTimeseriesResponse,
      { from?: string; to?: string } | void
    >({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params && "from" in params && params.from) searchParams.append("from", params.from);
        if (params && "to" in params && params.to) searchParams.append("to", params.to);
        const qs = searchParams.toString();
        return `/admin/ai-costs/timeseries${qs ? `?${qs}` : ""}`;
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetAiCostsOverviewQuery,
  useGetAiCostsSummaryQuery,
  useGetAiCostsTimeseriesQuery,
} = aiCostsApi;
